import { useTranslation } from 'react-i18next'
import { StatusIndicator } from 'packages/eid-ui'
import { Icon } from 'packages/eid-icons'
import CheckInButton from './CheckInButton'
import CheckOutButton from './CheckOutButton'
import ExtendButton from './ExtendButton'
import moment from 'moment'
import { Box, styled, Typography, useTheme } from '@mui/material'
import { useQuery } from 'packages/core'
import { useHistory } from 'react-router'
import { calculateRemainingTime } from 'utils'

const TaskIcon = styled(Box)(({ theme }) => ({
    width: '24px',
    height: '24px',
    background: theme?.palette?.primary?.main,
    border: `solid 1px ${theme?.palette?.primary?.main}`,
    borderRadius: '5px',
    padding: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: '12px',
}))

const TaskBadgeSection = styled(Box)({
    position: 'relative',
    cursor: 'pointer',
})

const CredentialStatusButton = ({ data }) => {
    const item = data?.resource
    const assignment = data?.assignment
    const { t } = useTranslation()
    const query = useQuery()
    const history = useHistory()
    const theme = useTheme()
    const checkedOutBySomeoneElse = item.isCheckedOutBySomeoneElse

    const isExtendable =
        assignment?.assignmentDetails?.timeConstraintActive &&
        moment(assignment?.assignmentDetails?.startDateUtc).isBefore(moment())

    const showCalenderIcon = item.checkOutCount > 0

    if (item.isExpired) {
        return (
            <Box>
                <StatusIndicator
                    className="Status-Indicator"
                    variant="Expired"
                    label={t('Expired')}
                    size="small"
                    style={{ display: 'inline-block' }}
                />
            </Box>
        )
    }

    if (item.canCheckIn) {
        return (
            <Box display="flex" alignItems="center">
                <CheckInButton data={data} drawerView={false} />
                {isExtendable && (
                    <div style={{ marginLeft: '16px' }}>
                        <ExtendButton data={data} />
                    </div>
                )}
                {showCalenderIcon && (
                    <TaskBadgeSection
                        onClick={() => {
                            query.set('selected', item.id)
                            query.set('showSession', true)
                            history.push(
                                `${
                                    history.location.pathname
                                }?${query.toString()}`,
                            )
                        }}
                    >
                        <TaskIcon>
                            <Icon name="ActiveCalender" />
                        </TaskIcon>
                        <span
                            style={{
                                position: 'absolute',
                                top: '-8px',
                                right: '-6px',
                                background: theme?.palette?.quaternary?.main,
                                height: '15px',
                                width: '15px',
                                borderRadius: '50%',
                                fontSize: '10px',
                                fontWeight: '500',
                                color: theme?.palette?.common?.white,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                paddingTop: '1px',
                            }}
                        >
                            {item.checkOutCount}
                        </span>
                    </TaskBadgeSection>
                )}
            </Box>
        )
    } else if (item.canCheckOut || checkedOutBySomeoneElse) {
        return (
            <Box display="flex">
                <CheckOutButton
                    data={data}
                    drawerView={false}
                    checkedOutBySomeoneElse={checkedOutBySomeoneElse}
                />
                {isExtendable && (
                    <div style={{ marginLeft: '16px' }}>
                        <ExtendButton data={data} />
                    </div>
                )}
                {showCalenderIcon && (
                    <TaskBadgeSection
                        onClick={() => {
                            query.set('selected', item.id)
                            query.set('showCheckouts', true)
                            history.push(
                                `${
                                    history.location.pathname
                                }?${query.toString()}`,
                            )
                        }}
                    >
                        <TaskIcon>
                            <Icon name="ActiveCalender" />
                        </TaskIcon>
                        {/* <span style={{position: 'absolute',
                                top: '-8px',
                                right: '-6px',
                                background: theme?.palette?.quaternary?.main,
                                height: '15px',
                                width: '15px',
                                borderRadius: '50%',
                                fontSize: '10px',
                                fontWeight: '500',
                                color: theme?.palette?.common?.white,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                paddingTop: '1px'}}>
                                {item.checkOutCount}
                            </span> */}
                    </TaskBadgeSection>
                )}
            </Box>
        )
    } else if (!(item?.canCheckIn && item?.canCheckOut)) {
        const currentTime = new Date().toISOString()
        if (!item?.checkOutStartTimeUtc) {
            return '-'
        }
        const duration = calculateRemainingTime(
            currentTime,
            item?.checkOutStartTimeUtc,
        )
        const time = `${duration?.hours} ${t('hours')} ${duration?.minutes} ${t(
            'mins',
        )}`
        const daysLabel = duration.days > 1 ? t('days') : t('day')

        const durationInDays = duration.days + ' ' + daysLabel + ' ' + time

        const remainingTime = duration.days > 0 ? durationInDays : time
        return (
            <Typography sx={{ fontSize: '1.2rem' }}>
                {t('CredentialCheckoutMessage')}
                <br />
                <strong>{remainingTime}</strong>
            </Typography>
        )
    } else return <>-</>
}

CredentialStatusButton.defaultProps = {
    drawerView: false,
}

export default CredentialStatusButton
